import Vue from 'vue'
import Vuex from 'vuex'

import pre from './modules/pre'
import sign from './modules/sign'
import take from './modules/take'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    pre,
    sign,
    take,
  },
  state: {},
  mutations: {},
  actions: {},
  getters,
})
